import { type AnyExtension } from "@tiptap/core";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";

import { Embed } from "./embed";
import { WidgetNode } from "./widget-node";

/**
 * The one schema for post bodies. The admin editor and the server-side HTML renderer must use
 * the same list, or published HTML silently drops nodes the editor allowed.
 */
export const createPostExtensions = (overrides: { widget?: AnyExtension } = {}): AnyExtension[] => [
  StarterKit.configure({ heading: { levels: [2, 3, 4] } }),
  Underline,
  Link.configure({
    openOnClick: false,
    autolink: true,
    protocols: ["https", "http", "mailto"],
    HTMLAttributes: { rel: "noopener noreferrer", target: null },
  }),
  Image.configure({ inline: false, allowBase64: false }),
  Embed,
  // The admin editor passes a version with a React preview; the schema is the same.
  overrides.widget ?? WidgetNode,
];
